module.exports = __webpack_public_path__ + "static/img/guanbi1_btn.9a87d2bc.png";